/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarElement\CarElement3.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday February 9th 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Monday, 6th November 2023 04:42:50
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect, useState } from "react";
import CarCost from "Content/Car/CarCost/CarCost";
import CarInfo from "Content/Car/CarInfo/CarInfo";
import { useLoaderData } from "react-router-dom";
import CarSingleCarousel from "Content/Car/CarSingleCarousel/CarSingleCarousel";
import styles from "Content/Car/CarElement/CarElement.module.css";
import CarCardHeader from "Content/Car/CarCardHeader/CarCardHeader";
import CarEquipment from "Content/Car/CarEquipment/CarEquipment";
import translator from "MultiLanguage/TranslationWrapper";
import { BsFillTelephoneInboundFill as Phone , BsCalendarDate as CalendarDate } from "react-icons/bs";
import ModalCta from "Content/Modals/ModalCta/ModalCta";
import ButtonAlt from "Theme/Component/ButtonAlt";
import HrStyled from "Theme/Component/HrStyled";
import HolderStyled from "Theme/Component/HolderStyled";
import { useMyContext } from "Content/Main/Main";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from "Config/Cookies/CookiePathResolver";
import CarService from "Services/Cars/CarService";
import { SingleCarFormat } from "Content/Car/CarElement/CarElement.type";
import RentingTool from "Content/RentingTool/RentingTool";
import ModalContact from "Content/Modals/ModalContact/ModalContact";

function CarElement(_: any) {
    const singleCar: SingleCarFormat = useLoaderData() as SingleCarFormat;
    const [carImg, setCarImg] = useState([]);
    const [carEquipment, setCarEquipment] = useState([]);
    const [modalCta, setModalCta] = useState(false);
    const [modalContact, setModalContact] = useState(false);
    const myCookies: number[] = Cookie.getCookie(CookiePathResolver.CAR.FAVORITE);
    const themeColor: string = singleCar.iconSubSection.IconSubSection;
    const { setterThemeColor } = useMyContext();

    useEffect(()=>{
        setterThemeColor(themeColor);
    },[]);

    const checkIsLiked = (id: number) => {
        return myCookies !== undefined && myCookies.includes(id);
    };

    const handleToggleCtaModal = (e: React.MouseEvent<HTMLElement>) => {
        setModalCta(false);
    };
    const handleToggleContactModal = (e: React.MouseEvent<HTMLElement>) => {
        setModalContact(false);
    };

    useEffect(() => {
        CarService.getPicturesForOneCar(singleCar.id).then((val) => setCarImg(val));
        CarService.getEquipementsForOneCar(singleCar.id).then((val) => {setCarEquipment(val)});
    }, []);

    return (
        <React.Fragment>
            <div className={`${styles.carElementContainer}`}>
                <div className={`${styles.btnPosPhone}`}>
                    {
                        singleCar.carInfo.Status.toLowerCase() != "sold" ?
                        <ButtonAlt bgColor={themeColor} borderRadius={0} onClick={()=> setModalCta(true)} type="submit"><Phone size={"2rem"}/></ButtonAlt>
                        : null
                    }
                    <ButtonAlt bgColor={themeColor} borderRadius={0} onClick={()=> setModalContact(true)} type="submit"><CalendarDate size={"2rem"}/></ButtonAlt>
                </div>
                <div className={`${styles.widthCarou}`}>
                    <HolderStyled bgColor={themeColor} className={`${styles.carElementContainerLeft}`}>
                        <div className={`${styles.carouselContainer}`}>
                            {
                                singleCar.carInfo.Status.toLowerCase() == "sold" ? <div className={`${styles.sold}`}> <p>{translator.decode("car.sold")}</p> </div> : null
                            }
                            {
                                singleCar.carInfo.Status.toLowerCase() == "reserved" ? <div className={`${styles.reserved}`}> <p>{translator.decode("car.reserved")}</p> </div> : null
                            }
                            <CarCardHeader IconSubSection={singleCar.iconSubSection.IconSubSection} id={singleCar.id} themeColor={themeColor} IsFav={checkIsLiked(singleCar.id)}/>
                            <CarSingleCarousel pictureObjects={carImg} themeColor={themeColor} />
                        </div>
                    </HolderStyled>
                    <HolderStyled bgColor={themeColor} className={`${styles.carEquipmentHolder}`}>
                        <div className={`${styles.carInfoPhone}`}>
                            <CarInfo Brand={singleCar.carInfo.Brand} Model={singleCar.carInfo.Model} Version={singleCar.carInfo.Version}
                            Energy={singleCar.carInfo.Energy} Gears={singleCar.carInfo.Gears} CirculationDate={singleCar.carInfo.CirculationDate}
                            Mileage={singleCar.carInfo.Mileage} Park={singleCar.carInfo.StoragePlace.City} Color={singleCar.carInfo.Color} Nb_Col={2} Nb_Elem={8} Car_Type={singleCar.carInfo.CarType.Name} themeColor={themeColor} Link={singleCar.carInfo.Link ?? ""} />
                        </div>
                        <div className={`${styles.carCostPhone}`}>
                            <CarCost carCost={singleCar.carInfo.SellPrice} themeColor={themeColor} rentalCost={0} />
                        </div>
                        <h2 className={"titleEquipment"}>{translator.decode("categories.equipments")?.toUpperCase()}</h2>
                        {
                            carEquipment.length != 0 ? <CarEquipment Equipment={carEquipment} themeColor={themeColor}/> :null
                        }
                    </HolderStyled>
                </div>
{/*-------------------------- Box sticky avec CarInfo + Price + 2 btn------------------------------ */}
                <div className={`${styles.carElementContainerRight}`}>
                    <HolderStyled bgColor={themeColor} className={`${styles.boxRight}`} >
                        <div className={`${styles.carElementInfoContainer} ${styles.resetPaddingTopBotCarInfo} col-12`}>
                            <CarInfo Brand={singleCar.carInfo.Brand} Model={singleCar.carInfo.Model} Version={singleCar.carInfo.Version}
                            Energy={singleCar.carInfo.Energy} Gears={singleCar.carInfo.Gears} CirculationDate={singleCar.carInfo.CirculationDate}
                            Mileage={singleCar.carInfo.Mileage} Park={singleCar.carInfo.StoragePlace.City} Color={singleCar.carInfo.Color} Nb_Col={2} Nb_Elem={8} Car_Type={singleCar.carInfo.CarType.Name} themeColor={themeColor} Link={singleCar.carInfo.Link ?? ""} />
                        </div>
                        <HrStyled bgColor={themeColor}/>
                        <div className={`${styles.separatingLineHolder}`}>
                            <div className={`${styles.ctaCarCost}`}>
                                <CarCost carCost={singleCar.carInfo.SellPrice} themeColor={themeColor} rentalCost={0} />
                            </div>
                        </div>
                        <HrStyled bgColor={themeColor}/>
                        <div className={`${styles.posbtnAlt}`}>
                            {
                                singleCar.carInfo.Status.toLowerCase() != "sold" ? <ButtonAlt bgColor={themeColor} minWidth={"35%"} onClick={()=> setModalCta(true)} type="submit">{translator.decode("carElem.reservation")}</ButtonAlt>
                                : null
                            }
                            <ButtonAlt bgColor={themeColor} onClick={()=> setModalContact(true)} type="submit">{translator.decode("carElem.contact")}</ButtonAlt>
                        </div>
                        <ModalCta show={modalCta} onClose={handleToggleCtaModal} closeModal={handleToggleCtaModal} themeColor={themeColor}/>
                        <ModalContact show={modalContact} onClose={handleToggleContactModal} closeModal={handleToggleContactModal} themeColor={themeColor} category={singleCar.iconSubSection.IconSubSection} energy={singleCar.carInfo.Energy} brand={singleCar.carInfo.Brand} model={singleCar.carInfo.Model} carId={singleCar.id} mileage={singleCar.carInfo.Mileage} />
                    </HolderStyled>
                    {/* <HolderStyled bgColor={themeColor} className={`${styles.boxRight}`} >
                        <RentingTool border={0} bgColor={themeColor} SellPrice={singleCar.carCost.carCost} Mileage={10000} Contribution={1000} MonthsNb={36} />
                    </HolderStyled> */}
                </div>
{/*-------------------------- Box sticky avec CarInfo + Price + 2 btn------------------------------ */}
            </div>
        </React.Fragment>
    );
}

export default CarElement;
